export enum URLQueryParamNames {
  Fagomrade = 'fagomrade',
  Malgruppe = 'malgruppe',
  VerktoyType = 'verktoytype',
  Sortering = 'sortering',
  SorterStigende = 'sorterstigende',
  Sok = 'sok',
  StotterAnonymOppstart = 'stotteranonymoppstart',
}
